/**
 * This module manages the account switcher within the user interface, including
 * its interacts, the select 2 binding, auto complete functionality and various UX
 * management.
 */
var $ = require('jQuery');
var accountSwitcher = $('#accountSwitcher');
var language = $('#accountName').data('language');

$('#accountName').click(function(e) {
  e.preventDefault();

  $.extend($.fn.select2.defaults, $.fn.select2.locales[language]);

  accountSwitcher.select2({
    placeholder: '',
    containerCssClass: 'account-switcher',
    dropdownCssClass: 'account-switcher-dropdown',
    minimumInputLength: 2,
    ajax: {
      url: '/auth/accounts',
      dataType: 'json',
      quietMillis: 250,
      data: function (term, page) { // page is the one-based page number tracked by Select2
        return {
          q: term // search term
        };
      },
      results: function (data, page) {
        // notice we return the value of more so Select2 knows if more results can be loaded
        return { results: data };
      }
    },
    formatResult: function(repo) {
      return '<span class="account-switcher-result">' + repo.text + '</span>';
    },
    formatSelection: function(repo) {
      return repo.text;
    }
  });

  // Open immediately
  accountSwitcher.select2('open');
});

accountSwitcher.on('select2-selecting', function(e) {
  // On select redirect to new account.
  window.location.href = '/auth/account/' + e.val;
});

accountSwitcher.on('select2-close', function(e) {
  // Select2 tries to refocus on the input element when closing - let it do that
  // before destroying it to avoid an uncaught TypeError.
  setTimeout(function() {
    accountSwitcher.select2('destroy');
  }, 25);
});

$(document).on('keydown', function (e) {
  if (e.keyCode === 27) { // ESC
    accountSwitcher.select2('destroy');
  }
});
